<template>
  <div v-if="!$fetchState.pending">
    <PostPage v-if="pageType === 'post'" />
    <CategoryPage v-if="pageType === 'category'" />
  </div>
</template>
<script>
export default {
  name: 'Page',
  components: {
    PostPage: () => import('@/components/blog/post/PostPage.vue'),
    CategoryPage: () => import('@/components/blog/categories/CategoryPage.vue'),
  },
  layout: 'blog',
  middleware: 'blogCheck',
  async fetch() {
    const { state } = this.$store;

    if (this.pageType === 'category') {
      await Promise.all([
        // Category List
        this.$store.dispatch('category/getCategories'),
        this.$store.dispatch('post/getPosts', {
          filter: {
            categories: state.category.selectedCategory.id,
            per_page: 11,
            page: this.$route?.query?.page,
            search: this.$route?.query?.q,
          },
        }),
        // Get Featured Post of Category
        this.$store.dispatch('post/getFeaturedPost', {
          filter: {
            categories: state.category.selectedCategory.id,
          },
        }),
      ]);
    } else if (state.post.post) {
      const { post } = state.post;

      // Get Similar Posts
      await this.$store.dispatch('post/getSimilarPosts', post.id);

      if (post.acf?.airport_slug?.length) {
        const airport = this.$store.state.airports.find((airport) => airport.slug === post.acf.airport_slug);
        if (airport) this.$store.commit('airportPicker/select', airport);
      }
    }

    this.$store.commit('bucket/update', {
      key: 'page_type',
      value: `blog_${this.pageType}`,
    });
  },
  head() {
    const script = [];
    if (process.env.DATA_ANALYTICS_BUCKET === '1') {
      const bucketSourcePrefix = process.env.NODE_ENV === 'production' ? '/_nuxt_blog_pages' : '';
      const bucketSource = `${bucketSourcePrefix}/da-bucket/dist/blog-pages/index.js`;

      const bucketScript = {
        src: bucketSource,
        body: true,
      };

      script.push(bucketScript);
    }

    return {
      script,
    };
  },
  computed: {
    languages() {
      return this.$store.state.languages;
    },
    pageType() {
      return this.$store.state.pageType;
    },
  },
  mounted() {
    this.$store.commit('bucket/update', {
      key: 'page_type',
      value: `blog_${this.pageType}`, // either 'blog_post' or 'blog_category'
    });
  },
};
</script>
